var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdtVires(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "#7EE989",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8589 8.13672L4.02399 20.393C4.00179 20.4386 3.99475 20.49 4.00391 20.5399C4.01307 20.5898 4.03795 20.6354 4.0749 20.6701L19.8336 35.7708C19.8784 35.8137 19.938 35.8377 20 35.8377C20.062 35.8377 20.1216 35.8137 20.1664 35.7708L35.9251 20.6711C35.9621 20.6364 35.9869 20.5907 35.9961 20.5409C36.0052 20.491 35.9982 20.4395 35.976 20.3939L30.1411 8.13767C30.1223 8.0965 30.092 8.06163 30.0539 8.03723C30.0157 8.01282 29.9714 7.9999 29.9261 8.00002H10.0757C10.0303 7.99945 9.98559 8.01206 9.94711 8.03631C9.90864 8.06057 9.878 8.09544 9.8589 8.13672V8.13672V8.13672Z",
    fill: "#50AF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0246 21.6516C21.9114 21.6601 21.3269 21.6949 20.023 21.6949C18.986 21.6949 18.2497 21.6638 17.9913 21.6516C13.9835 21.4753 10.9921 20.7776 10.9921 19.9423C10.9921 19.107 13.9835 18.4103 17.9913 18.2311V20.9567C18.2534 20.9756 19.0039 21.0199 20.0409 21.0199C21.2854 21.0199 21.9086 20.9681 22.0208 20.9577V18.233C26.0201 18.4112 29.005 19.1089 29.005 19.9423C29.005 20.7757 26.0211 21.4734 22.0208 21.6506L22.0246 21.6516ZM22.0246 17.9511V15.5121H27.6059V11.7928H12.41V15.5121H17.9904V17.9502C13.4546 18.1585 10.0436 19.057 10.0436 20.1337C10.0436 21.2104 13.4546 22.1079 17.9904 22.3172V30.1329H22.0236V22.3144C26.549 22.106 29.9544 21.2085 29.9544 20.1327C29.9544 19.057 26.5518 18.1595 22.0236 17.9502L22.0246 17.9511Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtVires);
export default __webpack_public_path__ + "static/media/USDT_VIRES.cfbe761d479780d99b5dca642ca6528e.svg";
export { ForwardRef as ReactComponent };